import { render, staticRenderFns } from "./sign-head.vue?vue&type=template&id=81cbf1c0"
import script from "./sign-head.vue?vue&type=script&lang=js"
export * from "./sign-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports